import { Component, Input, OnInit } from '@angular/core'
import { LogEvent } from 'src/app/interfaces/log'
import { LogService } from 'src/app/services/log/log.service'
import { ModalService } from 'src/app/services/modal/modal.service'

@Component({
  selector: 'app-profile-guide',
  templateUrl: './profile-guide.component.html',
  styleUrls: ['./profile-guide.component.scss'],
})
export class ProfileGuideComponent implements OnInit {
  constructor(private modalService: ModalService, private logService: LogService) {}

  @Input() title = '내 프로필에서 결과 확인'
  @Input() description = '상단 메뉴> 내 프로필에서<br />진행중인 모든 결과를 볼 수 있어요'
  @Input() buttonText = '분석 완료되면 알림받기'

  ngOnInit() {
    this.logService.eventLogging(LogEvent.PROFILE_GUIDE_MODAL_VIEWED, { from: location.pathname })
  }

  onClickClose(): void {
    this.modalService.dismiss()
  }

  onClickAlarmButton(): void {}
}
